export default __webpack_public_path__ + "static/media/ki.49d96317.svg";